import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery } from '../../utils/category';
import { EOfferType } from '../../utils/jsonQuery';
import { selectOfferType } from '../../actions/filters';
import { FilterOfferType } from '../../components/FilterOfferType';
import { getOfferTypeLabel } from '../../utils/offerType';
import { getOfferTypeList } from './helpers';
import { selectJsonQuery } from '../../selectors/filters/selectJsonQuery';
import { TThunkDispatch } from '../../types/redux';

export const FilterOfferTypeContainer = () => {
  const jsonQuery = useSelector(selectJsonQuery);

  const dispatch: TThunkDispatch = useDispatch();

  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const list = getOfferTypeList(dealType);
  const label = getOfferTypeLabel(offerType);

  return (
    <FilterOfferType
      onSelect={(offerType: EOfferType) => dispatch(selectOfferType(offerType))}
      list={list}
      label={label}
      offerType={offerType}
    />
  );
};
